<template>
	<div class="widget___settings">
		<ul>
			<li v-for="[key, val] in Object.entries(para.settings)" :key="key">
				<b>{{ key }}</b>
				<el-select v-if="getSelectOptions(key)" :value="val" @change="v => onChangeSetting(key, v)" filterable>
					<el-option v-for="option in getSelectOptions(key)" :key="option.value" :label="option.label" :value="option.value" />
				</el-select>
				<el-input v-else :value="val" @input="v => onChangeSetting(key, v)" />
			</li>
		</ul>
		<div style="width: fit-content; margin: auto">
			<sf-button line icon="file" color="blue" :onClick="onApply">{{ getMessage_('SWCC000602') }}</sf-button>
			<sf-button line icon="close" :onClick="onCancel">{{ getMessage_('SWCC000191') }}</sf-button>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		para: {
			type: Object,
			deafult: () => ({})
		},
		widgetComponent: {
			type: Object,
			deafult: () => ({})
		},
		refreshPara: {
			type: Function,
			default: () => {}
		},
		onChange: {
			type: Function,
			default: () => {}
		}
	},
	computed: {
		...rootComputed
	},
	methods: {
		getSelectOptions(key) {
			const options = _.get(this.widgetComponent, `_data.${key}Options`);
			return options;
		}
	},
	onApply() {
		this.onChange({ i: this.params.i, settings: this.para.settings });
		this.toggleSetting();
	},
	onCancel() {
		this.refreshPara();
		this.toggleSetting();
	}
};
</script>

<style></style>
